import React, { useState, useEffect } from 'react';
import { getMenu } from '../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('');
  const [menuCategories, setMenuCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getMenu();
        setMenuCategories(data);
        if (data.length > 0) setActiveCategory(data[0].id);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };
    fetchData();
  }, []);

  if (menuCategories.length === 0) return null;

  return (
    <section id="menu" className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className="md:text-6xl !font-bold !text-5xl mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}>Nuestro Menu


          </h2>
          <p className="max-w-2xl !text-lg mx-auto text-gray-600">Descubra nuestra selección de auténticos platillos franceses, preparados con amor y los mejores ingredientes.

          </p>
        </div>

        <Tabs value={activeCategory} onValueChange={setActiveCategory} className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-5 mb-12 bg-gray-100 p-1 rounded-lg">
            {menuCategories.map((category) =>
            <TabsTrigger
              key={category.id}
              value={category.id}
              className="data-[state=active]:bg-black data-[state=active]:text-white transition-all duration-200 rounded-md">

                {category.name}
              </TabsTrigger>
            )}
          </TabsList>

          {menuCategories.map((category) =>
          <TabsContent key={category.id} value={category.id} className="mt-0">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-semibold mb-2">{category.name}</h3>
                <p className="text-gray-600">{category.description}</p>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.items.map((item) =>
              <Card
                key={item.id}
                className="overflow-hidden hover:shadow-lg transition-shadow duration-200"
                style={{ backgroundColor: '#F5B8D0' }}>

                    <CardHeader>
                      <div className="flex justify-between items-start">
                        <CardTitle className="text-xl">{item.name}</CardTitle>
                        <span className="text-lg font-bold">${item.price.toFixed(2)}</span>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-gray-700">
                        {item.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
              )}
              </div>
            </TabsContent>
          )}
        </Tabs>
      </div>
    </section>);

};

export default Menu;